module.exports = __webpack_public_path__ + "img/ease-for-companies.987d3b39.png";